<ap-grid-row>
    <ap-grid-col class="ap-align-center">
        <div class="ap-margin-bottom-4 ap-display-block">
            <ap-illustration [name]="'error'"></ap-illustration>
        </div>
        <h1 class="ap-margin-bottom-2 ap-display-block">{{ 'tokens.browser.' + apError.context + '.error.title' | apContent }}</h1>
        <div class="ap-margin-bottom-4 ap-display-block">
            <ap-content [key]="'tokens.browser.' + apError.context + '.error.info'"></ap-content>
        </div>
        @if (hasAction(apError.context)) {
            <div class="ap-margin-bottom-4 ap-display-block">
                <ap-button type="button" (onClick)="performAction(apError.context)" data-bb="performAction">
                    {{ 'tokens.browser.' + apError.context + '.error.action' | apContent }}
                </ap-button>
            </div>
        }
    </ap-grid-col>
</ap-grid-row>
